import React from "react";
import Layout from "../../Layout.json";
import Normal from "../../Layouts/Normal/Normal";
import Double from "../../Layouts/Double/Double";
import DoubleSubtitle from "../../Layouts/DoubleSubtitle/DoubleSubtitle";
import Picture from "../../Layouts/Picture/Picture";
import PictureLeft from "../../Layouts/PictureLeft/PictureLeft";
import PictureRight from "../../Layouts/PictureRight/PictureRight";
import Chart from "../../Layouts/Chart/Chart";
import { updatePreview } from "./updatePreview";
import { onChange } from "./onChange";
import NormalChart from "../../Layouts/NormalChart/NormalChart";
import SubtitleChart from "../../Layouts/SubtitleChart/SubtitleChart";

export const getLayout = (props, id, layoutType, data, debounced) => {
	switch (layoutType) {
		case Layout.normal:
			return (
				<Normal
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		case Layout.double:
			return (
				<Double
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		case Layout.doubleSubtitle:
			return (
				<DoubleSubtitle
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		case Layout.picture:
			return (
				<Picture
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		case Layout.pictureLeft:
			return (
				<PictureLeft
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		case Layout.pictureRight:
			return (
				<PictureRight
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		case Layout.chart:
			return (
				<Chart
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		case Layout.normalChart:
			return (
				<NormalChart
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		case Layout.subtitleChart:
			return (
				<SubtitleChart
					id={id}
					onChange={(data) => onChange(props, debounced, data)}
					data={data}
					updatePreview={(id) => updatePreview(props, id)}
				/>
			);

		default:
			break;
	}
};
